module.exports = __webpack_public_path__ + "img/package-check.a95fe283.svg";